module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/campaign_eight_sp-4c217e2f41cb5cc942d2dc960cc2baf3.png";